<template>
  <div class="screen-wrapper" :style="screenWrapperStyle">
    <div class="screen" data-model-id="pub:screen" :style="screenStyle">
      <img
        class="rectangle-2"
        alt="Rectangle"
        src="/static/img/pub-rectangle-148387.svg"
      />
      <img
        class="main-product-bg"
        alt="Main product bg"
        src="/static/img/pub-main-product-bg-1.png"
      />
      <img
        class="mask-group"
        alt="Mask group"
        src="/static/img/pub-mask-group.png"
        v-anim="'animate__fadeIn'"
        style="animation-delay:0.05s"
      />
      <div class="text-wrapper-20" v-anim="'animate__fadeInDown'" style="animation-delay:0.1s">云帆公告</div>
      <HeaderSubsection :fixed="true" :logoSrc="'/static/img/pub-image-506@2x.png'" />
      <img class="image-2" alt="Image" src="/static/img/pub-image-41.png" v-anim="'animate__fadeInUp'" style="animation-delay:0.15s" />
      <PubGroupSubsection v-anim="'animate__fadeInUp'" style="animation-delay:0.2s" />
      <PubListSubsection ref="list" :items="items" v-anim style="animation-delay:0.25s" @select="onSelectItem" />
      <Group3Subsection :top="footerTop" v-anim="'animate__fadeInUp'" style="animation-delay:0.3s" />
    </div>
  </div>
</template>

<script>
import HeaderSubsection from "../Screen/sections/HeaderSubsection.vue";
import Group3Subsection from "../Screen/sections/Group3Subsection.vue";
import PubGroupSubsection from "./sections/PubGroupSubsection.vue";
import PubListSubsection from "./sections/PubListSubsection.vue";
import { getAnnouncements } from "../../directus/api.js";

export default {
  name: "PubScreen",
  components: {
    HeaderSubsection,
    PubGroupSubsection,
    PubListSubsection,
    Group3Subsection,
  },
  directives: {
    anim: {
      inserted(el, binding) {
        const cls = binding && binding.value ? binding.value : "animate__fadeInUp";
        el.classList.add("animate__animated");
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((e) => {
              if (e.isIntersecting) {
                el.classList.add(cls);
                io.unobserve(el);
              }
            });
          },
          { threshold: 0.2 }
        );
        io.observe(el);
      },
    },
  },
  data() {
    return {
      baseWidth: 1920,
      baseHeight: 904,
      targetWidth: 1920,
      viewportWidth: 0,
      viewportHeight: 0,
      footerTop: 2099,
      items: [],
    };
  },
  computed: {
    scale1() {
      const w = this.viewportHeight || this.targetHeight;
      const clamped = Math.min(w, this.baseHeight);
      return this.baseHeight / clamped;
    },
    scale() {
      const w = this.viewportWidth || this.targetWidth;
      const clamped = Math.min(w, this.baseWidth);
      return clamped / this.baseWidth;
    },
    pageHeight() {
      return Math.max(this.baseHeight, this.footerTop + 233);
    },
    screenStyle() {
      return {
        transform: `scale(${this.scale})`,
        transformOrigin: "top center",
        width: this.baseWidth + "px",
        position: "relative",
        minHeight: this.pageHeight + "px",
        
      };
    },
    screenWrapperStyle() {
      return {
        width: "100%",
        height: this.pageHeight * this.scale + "px",
        minHeight: "100vh",
        display: "flex",
        justifyContent:  "center",
        alignItems: "flex-start",
      };
    },
  },
  mounted() {
    this.viewportWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    this.viewportHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    window.addEventListener("resize", this.onResize);
    this.$nextTick(() => {
      this.updateFooterTop();
    });
    getAnnouncements(50)
      .then((list) => {
        if (Array.isArray(list)) {
          this.items = list;
          this.$nextTick(() => this.updateFooterTop());
        }
      })
      .catch(() => {});
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onSelectItem(item) {
      const id = item && item.id ? item.id : null;
      if (id) {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        this.$router.push({ path: "/pub-detail", query: { id } }).catch(() => {});
      }
    },
    onResize() {
      this.viewportWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      this.viewportHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;
      this.$nextTick(() => {
        this.updateFooterTop();
      });
    },
    updateFooterTop() {
      const listEl = this.$refs.list && this.$refs.list.$el ? this.$refs.list.$el : null;
      const listHeight = listEl ? listEl.offsetHeight : this.items.length * 274;
      const listTop = 907;
      const viewBase = (this.viewportHeight || this.baseHeight) / (this.scale || 1);
      const bottomSpace = 40;
      const footerHeight = 233;
      const desired = Math.max(listTop + listHeight + bottomSpace, viewBase - footerHeight);
      this.footerTop = Math.round(desired);
    },
  },
};
</script>

<style scoped>
.screen {
  min-width: 1920px;
  position: relative;
  width: 100%;
}

.screen-wrapper {
  width: 100%;
  position: relative;
  overflow: visible;
  min-height: 100vh;
}

.screen .rectangle-2 {
  height: 1531px;
  left: 0;
  position: absolute;
  top: 620px;
  width: 1920px;
}
.screen .main-product-bg {
  height: 858px;
  left: 0;
  position: absolute;
  top: 1293px;
  width: 1920px;
}
.screen .mask-group {
  height: 620px;
  left: 0;
  position: absolute;
  top: 0;
  width: 1920px;
}
.screen .text-wrapper-20 {
  color: #ffffff;
  font-family: "PingFang SC-Medium", Helvetica;
  font-size: 36px;
  font-weight: 500;
  left: 885px;
  letter-spacing: 1.8px;
  line-height: 54px;
  position: absolute;
  top: 283px;
  white-space: nowrap;
}
.screen .image-2 {
  height: 287px;
  left: 0;
  mix-blend-mode: darken;
  object-fit: cover;
  position: absolute;
  top: 620px;
  width: 1920px;
}
.screen .vector-2 {
  height: 1px;
  left: 194px;
  object-fit: cover;
  position: absolute;
  top: 1180px;
  width: 1510px;
}
.screen .vector-3 {
  height: 1px;
  left: 194px;
  object-fit: cover;
  position: absolute;
  top: 1472px;
  width: 1510px;
}
.screen .vector-4 {
  height: 1px;
  left: 194px;
  object-fit: cover;
  position: absolute;
  top: 1766px;
  width: 1510px;
}
.screen .vector-5 {
  height: 1px;
  left: 194px;
  object-fit: cover;
  position: absolute;
  top: 2060px;
  width: 1510px;
}
</style>
